import webpack from 'webpack';

export default (opts = {} )=> (
  new webpack.LoaderOptionsPlugin({
    minimize: true,
    debug: false,
    ...opts,
  })
);
